import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BenefitNetworkValue, Network } from '../models/network.model';
import { environment } from 'src/environments/environment';
import { ResourceService } from 'src/app/ui/services/resource.service';
import { ODataServiceFactory } from 'angular-odata';
import { RemoteGatewayFactory } from 'src/app/ui/gateways/remote-gateway-factory';
import { BackendUrl } from 'src/app/ui/models/domains/urls/back-end.url';
import { map, Observable } from 'rxjs';

const localUrl = environment.idpNetworkUrl;
@Injectable({
  providedIn: 'root'
})
export class NetworkService extends ResourceService<Network> {
  constructor(
    protected override factory: ODataServiceFactory,
    protected override http: HttpClient,
    private remoteGatewayFactory: RemoteGatewayFactory
  ) {
    super(factory, http);
  }

  override getResourceUrl(): string {
    return localUrl;
  }
  override getEntitySetName(): string {
    return 'Network';
  }

  public getBenefitById(benefitId: string, query: string): Observable<BenefitNetworkValue> {
    const url = `${this.getResourceUrl()}api/v1/NetworkBenefit/GetByBenefit?benefitId=${benefitId}&${query}`;
    return this.http.get<BenefitNetworkValue>(url).pipe(
      map((res: BenefitNetworkValue) => res)
    );
  }

  async getDocumentationLink(filename: string): Promise<any> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    return await remoteGateway.getWithHeaders(new BackendUrl("/api/network/document?fileName=" + filename), {});
  }

  async uploadDocumentation(formData: FormData): Promise<any> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    return await remoteGateway.postWithHeaders(new BackendUrl("/api/network/document/upload"), formData, {});
  }

  async deleteDocumentation(filename: string): Promise<any> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    return await remoteGateway.deleteWithHeaders(new BackendUrl("/api/network/document?fileName=" + filename), {});
  }
}
